import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

interface BackdropForDialogProps {
  loading?: boolean;
  hideSpinner?: boolean;
}

export const BackdropForDialog = ({ loading = false, hideSpinner = false }: BackdropForDialogProps) => {
  return (
    <Backdrop
      sx={{
        bgcolor: '#ffffffA0',
        color: (theme) => theme.palette.primary.main,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        position: 'absolute',
      }}
      open={loading}
    >
      {!hideSpinner && <CircularProgress color="inherit" />}
    </Backdrop>
  );
};
